<template>
    <div>
        <el-card>
            <div style="font-size: 14px;font-weight: 600;">月卡会员补偿</div>
            <div style="margin-top: 14px;">
                <el-alert title="2024年3月27日服务器维护补偿" type="info" effect="dark"
                    description="近期服务器维护给您带来了不便，我们深感抱歉，对此我们补偿1天月卡会员，只限月卡用户领取，限领取一次，感谢您的理解，祝您爆单！ (结束时间3月30日)" show-icon>
                </el-alert>
            </div>
            <div style="margin-top: 20px;">
                <el-button type="primary" style="margin-top: 10px;" @click="lq" :loading="lqing">立即领取补偿</el-button>
            </div>
        </el-card>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）

export default {
    name: '',
    components: {

    },
    // 定义属性
    data() {
        return {
            lqing: false
        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        lq() {
            this.lqing = true
            this.$ajax.post('qhy/user/buchang', {}, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                console.log(res.data)
                var jg = res.data
                this.$alert(res.data.msg, '提示', {
                    confirmButtonText: '确定',
                    customClass: 'msbox',
                    callback: action => {
                        this.lqing = false
                    }
                });
            })
        }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/components/User/Fan.vue


// WEBPACK FOOTER //
// src/components/User/Fan.vue